import { ContextMenuOptionType } from '@inno-ui/context-menu'
import { DropdownOption } from '@inno-ui/dropdown'
import { LANGUAGES } from 'shared/constants/Languages'

export const LANGUAGE_DROPDOWN_OPTIONS: DropdownOption[] = LANGUAGES.map(
  lang => ({
    label: lang.label,
    value: lang.value,
    avatar: lang.icon
  })
)

export const getLanguageContextMenuOptions = (
  currentLanguageValue: string,
  onLanguageChange: (langValue: string) => void
): ContextMenuOptionType[] =>
  LANGUAGES.map(lang => ({
    avatar: {
      url: lang.icon,
      objectFit: 'cover'
    },
    label: lang.label,
    isSelected: currentLanguageValue === lang.value,
    onClick: () => onLanguageChange(lang.value)
  }))
